export default __webpack_public_path__ + "static/juan-1736982eedf7d0d767d7f1e718aa0617.png";